// @ts-nocheck
import { DropDownFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import {
    DataOption,
    DataOptions,
    getDataOptionsFieldDefinition,
    getDataOptionValue,
} from "@toolkit/Framework/Common/Utilities/dataOptions";
import { LiteralUnion } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";

export type LinkVariantOption = DataOption<LinkPresentationProps>;
export interface LinkVariantOptionMapper {
    standard: LinkVariantOption;
    action: LinkVariantOption;
}
export type LinkVariantOptions = DataOptions<LinkVariantOption> & LinkVariantOptionMapper;
export type LinkVariant = LiteralUnion<keyof LinkVariantOptionMapper>;

export const linkVariantOptions: LinkVariantOptions = {
    standard: { id: "standard", displayName: "Standard", isDefault: true },
    action: { id: "action", displayName: "Action", value: { css: linkActionStyles() } },
};

export type LinkVariantFieldValue = LinkVariant | undefined;
export interface LinkVariantFieldOptions {
    isChildDefinition?: boolean;
}

export const getLinkVariantFieldData = (value: LinkVariantFieldValue, options?: LinkVariantFieldOptions) => {
    if (!value) {
        return undefined;
    }

    return getDataOptionValue(linkVariantOptions, value);
};

export const getLinkVariantFieldDefinition = (name: string, options?: LinkVariantFieldOptions) => {
    const { isChildDefinition } = options || {};

    const definition: DropDownFieldDefinition<string> = {
        ...getDataOptionsFieldDefinition(linkVariantOptions),
        name,
        displayName: "Link Variant",
        fieldType: !isChildDefinition ? "General" : (undefined as any),
        hideEmptyOption: true,
    };

    return definition;
};

const getLinkVariantField = (name: string, options?: LinkVariantFieldOptions) => {
    const parse = (value: LinkVariantFieldValue) => getLinkVariantFieldData(value, options);

    return {
        definition: getLinkVariantFieldDefinition(name, options),
        parse,
        useParse: (...parameters: Parameters<typeof parse>) => {
            return useMemo(() => parse(...parameters), parameters);
        },
    };
};

export default getLinkVariantField;
